import { useEffect, useState } from "react";
import { listCards } from "../../api/client";
import type { CardStatus } from "../../api/models";

/** Previous and next card ids within the same status filter, in list order. */
export function useNeighbours(id: number, status: CardStatus | undefined) {
  const [ids, setIds] = useState<number[]>([]);
  useEffect(() => {
    let cancelled = false;
    listCards({ status, pageSize: 200 })
      .then((l) => {
        if (!cancelled) setIds(l.items.map((c) => c.id));
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [status]);
  const i = ids.indexOf(id);
  return { prev: i > 0 ? ids[i - 1] : null, next: i >= 0 && i < ids.length - 1 ? ids[i + 1] : null };
}
